import React from 'react';

export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse rounded bg-secondary-200/60 dark:bg-secondary-700/50 ${className}`} />;
}

export function SkeletonText({ lines = 3 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`h-3 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}
